import { render, staticRenderFns } from "./ProyEcto.vue?vue&type=template&id=633ae946&scoped=true&"
import script from "./ProyEcto.vue?vue&type=script&lang=js&"
export * from "./ProyEcto.vue?vue&type=script&lang=js&"
import style0 from "./ProyEcto.vue?vue&type=style&index=0&id=633ae946&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ae946",
  null
  
)

export default component.exports